import React from 'react'

import { FeaturesSection as SharedFeaturesSection } from 'components/features-section/FeaturesSection'
import sdkIcon from 'shared/assets/icons/sdk.svg'
import rocketIcon from 'shared/assets/icons/rocket.svg'

import type { SoundscapePageCmsContent } from 'core/services/cms/interfaces'

interface FeaturesSectionProps {
  content: SoundscapePageCmsContent['features']
}

const PILL_ICONS = [sdkIcon, rocketIcon]

const FeaturesSection: React.FC<FeaturesSectionProps> = ({ content }) => {
  return (
    <SharedFeaturesSection
      title={content.title}
      features={content.blocks.map((block, index) => ({
        imageDesktop: block.imageDesktopUrl,
        imageMobile: block.imageMobileUrl,
        title: block.title,
        pillIcon: PILL_ICONS[index],
        pillText: block.pillText,
        reverse: index % 2 === 1,
        content: {
          heading: block.contentHeading,
          items: block.contentItems,
        },
      }))}
    />
  )
}

export default FeaturesSection
